export default "__VITE_ASSET__BIhIU300__"